const normalizeSpaces = (value) => String(value || '').replace(/\s+/g, ' ').trim();

const toIsoDate = (day, month, year) => {
  const fullYear = Number(year) < 100 ? 2000 + Number(year) : Number(year);
  return `${fullYear}-${String(month).padStart(2, '0')}-${String(day).padStart(2, '0')}`;
};

const monthNameToNumber = (value) => {
  const months = {
    jan: 1,
    feb: 2,
    mar: 3,
    apr: 4,
    may: 5,
    jun: 6,
    jul: 7,
    aug: 8,
    sep: 9,
    sept: 9,
    oct: 10,
    nov: 11,
    dec: 12
  };
  return months[String(value || '').slice(0, 4).toLowerCase()] || months[String(value || '').slice(0, 3).toLowerCase()] || null;
};

export const parseMpesaExpenseMessage = (text) => {
  const notes = String(text || '').trim();
  if (!notes) return null;

  const referenceMatch = notes.match(/^([A-Z0-9]{10})\b/i);
  if (!referenceMatch) return null;

  const paidMatch = notes.match(/Ksh\s*([\d,]+(?:\.\d{1,2})?)\s+paid\s+to\s+(.+?)\.\s+on\s+(\d{1,2})\/(\d{1,2})\/(\d{2,4})\b/i);
  const sentMatch = notes.match(/Ksh\s*([\d,]+(?:\.\d{1,2})?)\s+(?:sent|paid)\s+to\s+(.+?)(?:,\s*[\d*+\s-]+)?\s+via\s+.+?\s+on\s+(\d{1,2})(?:st|nd|rd|th)?\s+([A-Za-z]+)\s+(\d{2,4})\b/i);
  const match = paidMatch || sentMatch;
  if (!match) return null;

  const amount = Number(match[1].replace(/,/g, ''));
  if (!Number.isFinite(amount) || amount <= 0) return null;

  const month = paidMatch ? match[4] : monthNameToNumber(match[4]);
  if (!month) return null;

  return {
    reference: referenceMatch[1].toUpperCase(),
    amount: amount.toFixed(2),
    payeeName: normalizeSpaces(match[2]).toUpperCase(),
    transactionDate: toIsoDate(match[3], month, match[5]),
    paymentMethod: 'MPESA',
    notes
  };
};
